import * as XLSX from 'xlsx';

import type { BulkImportCreatedUserRow } from '../services/users.api';

const HEADERS = [
  'nombre',
  'email',
  'telefono',
  'id_externo',
  'asignable',
  'contraseña',
  'roles',
  'subproyectos',
] as const;

export function downloadBulkCreatedUsersExcel(rows: BulkImportCreatedUserRow[]): void {
  if (rows.length === 0) return;
  const dataRows = rows.map((r) => [
    r.nombre,
    r.email,
    r.phoneNumber ?? '',
    r.externalId ?? '',
    r.isAssignable ? 'si' : 'no',
    r.temporaryPassword,
    r.rolesDisplay,
    r.subProjectsDisplay,
  ]);
  const sheet = XLSX.utils.aoa_to_sheet([[...HEADERS], ...dataRows]);
  const book = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(book, sheet, 'Usuarios creados');
  XLSX.writeFile(book, 'usuarios_creados_lidz_contraseñas.xlsx');
}
